import Drawer from '@mui/material/Drawer';
import { CSSObject, Theme, styled } from '@mui/material/styles';
import { DRAWER_WIDTH } from '~/config';

const openedMixin = (theme: Theme, offset: number): CSSObject => ({
  width: DRAWER_WIDTH,
  borderRight: `1px solid ${theme.palette.divider}`,
  transition: theme.transitions.create(['width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  ...(offset > 0 && {
    top: offset,
    height: `calc(100% - ${offset}px)`,
  }),
});

const closedMixin = (theme: Theme, offset: number): CSSObject => ({
  transition: theme.transitions.create(['width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: theme.spacing(7.5),
  borderRight: 'none',
  ...(offset > 0 && {
    top: offset,
    height: `calc(100% - ${offset}px)`,
  }),
});

interface MiniDrawerStyledProps {
  open?: boolean;
  externalBannerOffset?: number;
}

const MiniDrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'externalBannerOffset',
})<MiniDrawerStyledProps>(({ theme, open, externalBannerOffset = 0 }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme, externalBannerOffset),
    '& .MuiDrawer-paper': openedMixin(theme, externalBannerOffset),
  }),
  ...(!open && {
    ...closedMixin(theme, externalBannerOffset),
    '& .MuiDrawer-paper': closedMixin(theme, externalBannerOffset),
  }),
}));

export default MiniDrawerStyled;
